var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"sotial-networks"},[(_vm.homeData)?_c('a',{staticClass:"mx-2",staticStyle:{"display":"flex","justify-content":"center"},attrs:{"href":_vm.homeData.settings.customer_setting
        ? _vm.homeData.settings.customer_setting.instagram
        : ''}},[_c('img',{staticClass:"instaFooter",attrs:{"src":require("../../../../assets/images/insta.jpg"),"alt":"insta"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }